(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["helmet-city-features"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {

  const sliders = document.querySelectorAll('.helmet-city-features__slider');

  sliders.forEach(function(slider){

    if (window.innerWidth < 990) return;

    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;

    slider.style.cursor = 'grab';

    slider.addEventListener('mousedown', function(e){
      isDown = true;
      slider.classList.add('dragging');
      slider.style.cursor = 'grabbing';

      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', function(){
      isDown = false;
      slider.classList.remove('dragging');
      slider.style.cursor = 'grab';
    });

    slider.addEventListener('mouseup', function(){
      isDown = false;
      slider.classList.remove('dragging');
      slider.style.cursor = 'grab';
    });

    slider.addEventListener('mousemove', function(e){

      if(!isDown) return;

      e.preventDefault();

      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1.5;

      slider.scrollLeft = scrollLeft - walk;

    });

    slider.addEventListener('wheel', function(e){

      if(Math.abs(e.deltaY) > Math.abs(e.deltaX)){
        e.preventDefault();
        slider.scrollLeft += e.deltaY;
      }

    }, { passive:false });

  });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
